<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Ajouter"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="addProspects"
    >
      <!-- account datails tab -->
      <tab-content title="Prospects">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Prospects</h5>
            <small class="text-muted">
              Information général sur le Prospects.
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nom" label-for="v-nom">
              <b-form-input
                id="v-nom"
                placeholder="Nom"
                v-model="prospects.firstName"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prénom" label-for="v-prenom">
              <b-form-input
                id="v-prenom"
                placeholder="Prénom"
                v-model="prospects.lastName"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email" label-for="v-email">
              <b-form-input
                id="v-email"
                placeholder="Email"
                v-model="prospects.email"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form
              ref="form"
              :style="{ height: trHeight }"
              class="repeater-form"
              @submit.prevent="repeateAgain"
            >
              <!-- Row Loop -->
              <b-row
                v-for="(item, index) in items"
                :id="item.id"
                :key="item.id"
                ref="row"
              >
                <!-- Item Name -->
                <b-col lg="9" md="9">
                  <b-form-group
                    label="Numéro de téléphone"
                    label-for="v-numero"
                  >
                    <b-form-input
                      id="v-numero"
                      placeholder="numero"
                      v-model="item.value"
                    />
                  </b-form-group>
                </b-col>
                <!-- Remove Button -->
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" class="mr-25" />
                  </b-button>
                </b-col>
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 mt-md-2"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                  </b-button>
                </b-col>
              </b-row>
              <b-col cols="12">
                <hr />
              </b-col>
            </b-form>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Adresse Prospects">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Adresse Prospects</h5>
            <small class="text-muted">Adresse du Prospects en détail</small>
          </b-col>
          <b-col md="8">
            <b-form-group label="Ville" label-for="v-ville">
              <b-form-input
                id="v-ville"
                placeholder="ville"
                v-model="prospects.city"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Code postal" label-for="v-cp">
              <b-form-input
                id="v-cp"
                placeholder="Code Postal"
                v-model="prospects.postalCode"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Adresse" label-for="v-adresse">
              <b-form-input
                id="v-adresse"
                placeholder="adresse"
                v-model="prospects.address"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Longitude" label-for="v-Longitude">
              <b-form-input
                id="v-Longitude"
                placeholder="00.0000"
                v-model="prospects.position.lng"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Latitude" label-for="v-Latitude">
              <b-form-input
                id="v-Latitude"
                placeholder="00.0000"
                v-model="prospects.position.lat"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Autre informations">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Autre informations</h5>
            <small class="text-muted">Autre informations</small>
          </b-col>
          <b-col md="4">
            <b-form-group label="Raison sociale" label-for="v-Raison">
              <b-form-input
                id="v-Raison"
                placeholder="Raison sociale"
                v-model="prospects.socialReason"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Secteur d'activité" label-for="v-activite">
              <b-form-input
                id="v-activite"
                placeholder="Secteur d'activité"
                v-model="prospects.activityArea"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Nom du responsable, Poste"
              label-for="v-responsable"
            >
              <b-form-input
                id="v-responsable"
                placeholder="Nom du responsable, Poste"
                v-model="prospects.responsible"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Type du prospect" label-for="v-Type">
              <b-form-input
                id="v-Type"
                placeholder="Type du prospect"
                v-model="prospects.type"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Type de vente" label-for="v-vente">
              <b-form-input
                id="v-vente"
                placeholder="Type de vente"
                v-model="prospects.saleType"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Remise" label-for="v-Discount">
              <b-form-input
                id="v-Discount"
                placeholder="Remise"
                v-model="prospects.discount"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Matricule Fiscale" label-for="v-Matricule">
              <b-form-input
                id="v-Matricule"
                placeholder="Matricule Fiscale"
                v-model="prospects.registrationNumber"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Jours de visite" label-for="v-Days">
              <v-select
                id="v-Days"
                v-model="prospects.visitingDays"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="optionDays"
                placeholder="Jours de visite"
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Statuts du prospect" label-for="v-Statuts">
              <b-form-input
                id="v-Statuts"
                placeholder="Statuts du prospect"
                v-model="prospects.status"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Budget du client" label-for="v-Budget">
              <b-form-input
                id="v-Budget"
                placeholder="Budget du client"
                v-model="prospects.clientBudget"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Chiffre d'affaire" label-for="v-Chiffre">
              <b-form-input
                id="v-Chiffre"
                placeholder="Chiffre d'affaire"
                v-model="prospects.turnover"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Capital" label-for="v-Capital">
              <b-form-input
                id="v-Capital"
                placeholder="Capital"
                v-model="prospects.capital"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Note" label-for="v-Note">
              <b-form-input
                id="v-Note"
                placeholder="Note"
                v-model="prospects.note"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { heightTransition } from "@core/mixins/ui/transition";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BForm,
    BButton,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [
        {
          id: 1,
          value: "",
        },
      ],
      nextTodoId: 2,
      optionCategorie: [],
      optionSubCategorie: [],
      optionDays: [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche",
      ],
      prospects: {
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        firstName: "",
        lastName: "",
        email: "",
        telNumbers: [],
        city: "",
        address: "",
        postalCode: "",
        position: {
          lat: "",
          lng: "",
        },
        socialReason: "",
        activityArea: "",
        responsible: "",
        type: "",
        saleType: "",
        discount: "",
        registrationNumber: "",
        visitingDays: [],
        status: "",
        clientBudget: "",
        turnover: "",
        capital: "",
        note: "",
      },
    };
  },
  mounted() {
    this.initTrHeight();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    addProspects() {
      this.prospects.telNumbers = [];
      this.items.forEach((element) => {
        this.prospects.telNumbers.push(element.value);
      });
      axios
        .post(
          "https://management-projects.herokuapp.com/api/prospects",
          this.prospects
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Prospects bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/prospect");
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
